import { OrderForm } from '@/components/trading/OrderForm';
import { OrdersTable } from '@/components/trading/OrdersTable';
import { PDTWarningBanner } from '@/components/compliance';
import { useQuery } from '@tanstack/react-query';
import { complianceService } from '@/services/compliance';

export function Trading() {
  // Fetch PDT status to determine if we should show the warning
  const { data: pdtStatus } = useQuery({
    queryKey: ['compliance', 'pdt-status'],
    queryFn: () => complianceService.getPDTStatus(),
    refetchInterval: 30000,
  });

  // Show warning banner if at limit or only 1 remaining
  const showPDTWarning = pdtStatus?.isAtLimit || pdtStatus?.remaining === 1;

  return (
    <div className="p-6 space-y-6">
      <div>
        <h1
          className="text-2xl font-semibold"
          style={{
            fontFamily: 'var(--font-display)',
            color: 'var(--fg)',
            letterSpacing: '-0.015em',
          }}
        >
          Trading
        </h1>
        <p
          style={{
            color: 'var(--fg-muted)',
            fontFamily: 'var(--font-mono)',
            fontSize: 11,
            textTransform: 'uppercase',
            letterSpacing: '0.14em',
            marginTop: 4,
          }}
        >
          Place and manage your paper trades
        </p>
      </div>

      {/* PDT Warning Banner - shown when at or near limit (T149) */}
      {showPDTWarning && <PDTWarningBanner />}

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-1">
          <OrderForm />
        </div>
        <div className="lg:col-span-2">
          <div className="space-y-4">
            <h2
              className="text-lg font-semibold"
              style={{
                fontFamily: 'var(--font-display)',
                color: 'var(--fg)',
                letterSpacing: '-0.01em',
              }}
            >
              Orders
            </h2>
            <OrdersTable />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Trading;
